export const formParsing = ({inputs, inputEntries}, {getParser}) => {
    const parsers = {
        text: input => input.value,
        checkBox: input => input.checked,
        radio: input => input.find(input => input.checked).value,
        date: input => ({
            day: input.day.value,
            month: input.month.value,
            year: input.year.value,
        }),
        custom: () => null,
    };

    const parser = getParser(parsers);
    //console.log(parser);

    const readValue = key => {
        console.log(key);
        // console.log(inputs[key]);
        return parser[key](inputs[key])
    };
    const readValues = () => Object.fromEntries(
        inputEntries.map(([key]) => [key, readValue(key)])
    );

    const c = {
        values: readValues(),
    };

    const setValue = (key, value) => c.values[key] = value;
    const updateValue = key => setValue(key, readValue(key));
    const getValues = () => c.values;
    const getValue = key => c.values[key];

    return {
        setValue,
        getValues,
        getValue,
        updateValue,
    };
};
